"use client";
import React from "react";
import { Controller } from "react-hook-form";

interface InputProps {
  name: any;
  control: any;
  errors: any;
  inputClassName?: string;
  wrapClassName?: string;
  subTitle?: string;
  checked: any;
  valueIn: any;
  [key: string]: any;
}
const Checkbox: React.FC<InputProps> = ({
  name,
  control,
  errors,
  inputClassName,
  wrapClassName,
  subTitle,
  checked,
  valueIn, // The dynamic value passed from the parent component
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div className="flex w-full items-center justify-between">
          <input
            type="radio"
            className="hidden"
            value={valueIn ?? ""} // Use valueIn instead of hardcoding the value
            onChange={(e) => {
              field.onChange(e.target.value); // Update form state with the selected value
              console.log("e.target.value", e.target.value); // Log the selected value for debugging
            }}
            onBlur={field.onBlur}
            checked={checked} // Ensure the correct radio button is selected
            {...props}
          />
        </div>
      )}
    />
  );
};

export default Checkbox;
